import { Component, input } from "@angular/core";

@Component({
    selector: "vds-dialog-content",
    template: "<ng-content />",
    host: { class: "vds-dialog-content", "[style.--vds-dialog-content-max-height]": "maxHeight()" },
    imports: []
})
export class VdsDialogContentComponent {
    public maxHeight = input<string>("60vh");
}
